import {
  ADD_ASPIRATIONS_QUESTION,
  EDIT_ASPIRATIONS_QUESTION,
  LIST_ASPIRATIONS_QUESTION,
  VIEW_ASPIRATIONS_QUESTION,
  DELETE_ASPIRATIONS_QUESTION,
  ADD_ASPIRATIONS_TEXT,
  EDIT_ASPIRATIONS_TEXT,
  LIST_ASPIRATIONS_TEXT,
  VIEW_ASPIRATIONS_TEXT,
  DELETE_ASPIRATIONS_TEXT,
  ASPIRATIONS_SUCCESS,
  ASPIRATIONS_ERROR,
} from "./actionTypes";

const initialState = {
  successMsg: null,
  error: null,
};

const aspirationsQuestion = (state = initialState, action) => {
  switch (action.type) {
    // add asiration question
    case ADD_ASPIRATIONS_QUESTION:
      state = {
        ...state,
        // loading: true,
        editLoading: true,

        successMsg: null,
        error: null,
      };
      break;
    case ASPIRATIONS_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        editLoading: false,

      };
      break;
    case ASPIRATIONS_ERROR:
      state = { ...state, error: action.payload, loading: false,editLoading:false };
      break;

    // edit asiration question
    case EDIT_ASPIRATIONS_QUESTION:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      };
      break;

    // list asiration question
    case LIST_ASPIRATIONS_QUESTION:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      };
      break;

    // view asiration question
    case VIEW_ASPIRATIONS_QUESTION:
      state = {
        ...state,
        successMsg: null,
        error: null,
      };
      break;

    // delete asiration question
    case DELETE_ASPIRATIONS_QUESTION:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      };
      break;

    // text
    // add asiration question
    case ADD_ASPIRATIONS_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      };
      break;
    case ASPIRATIONS_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        editLoading: false,
      };
      break;
    case ASPIRATIONS_ERROR:
      state = { ...state, error: action.payload, loading: false,editLoading:false };
      break;

    // edit asiration question
    case EDIT_ASPIRATIONS_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,

      };
      break;

    // list asiration question
    case LIST_ASPIRATIONS_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      };
      break;

    // view asiration question
    case VIEW_ASPIRATIONS_TEXT:
      state = {
        ...state,
        successMsg: null,
        error: null,
      };
      break;

    // delete asiration question
    case DELETE_ASPIRATIONS_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default aspirationsQuestion;
